// StartWorkButton.tsx
import React, { useState } from "react";
import { UniButton } from "../../../../../../@WUM/core/Elements";
import { clockTimingInterface } from "../../../../API/request/clockTimingInterface";
import {StartWork, StopBreak} from "../../../../API/response/worktimeclock";

interface StopBreakButtonProps {
    onSuccess?: (result: clockTimingInterface) => void;
}

const StopBreakButton = ({ onSuccess }: StopBreakButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleStart = async () => {
        setLoading(true);
        const result = await StopBreak();
        await StartWork();
        setLoading(false);

        if (result) {
            localStorage.setItem("workStart", new Date().toISOString());
            onSuccess?.(result);
        }
    };

    return (
        <UniButton disabled={loading} onClick={handleStart} class={""} variant={"success"}>
            {loading ? "..." : "🔄 Pause beenden"}
        </UniButton>
    );
};

export default StopBreakButton;
